export default function VisionMission() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="mb-8">
              <span className="inline-block px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold mb-4">
                OUR MISSION
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                私たちの使命
              </h2>
              <div className="w-16 h-1 bg-blue-600 rounded-full mb-8"></div>
            </div>
            
            <div className="space-y-8">
              <div className="bg-gradient-to-r from-blue-50 to-white p-8 rounded-2xl border-l-4 border-blue-600">
                <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                  Reason To Believe
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  私たちは「信頼される理由」を常に追求し続けます。単なるサービス提供ではなく、
                  なぜそのサービスが必要なのか、どのような価値を生み出すのかを明確に示し、
                  お客様に納得していただける理由を提供します。
                </p>
                <p className="text-gray-600 leading-relaxed">
                  建物という大切な資産に関わる私たちだからこそ、
                  一つひとつの判断に責任を持ち、信頼に応える結果を出し続けることが使命です。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center p-6 bg-blue-50 rounded-xl">
                  <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-user-heart-line text-white text-2xl"></i>
                    </div>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">お客様</h4>
                  <p className="text-sm text-gray-600">最適な答えを提供</p>
                </div>

                <div className="text-center p-6 bg-green-50 rounded-xl">
                  <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-team-line text-white text-2xl"></i>
                    </div>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">グループ</h4>
                  <p className="text-sm text-gray-600">共に成長する仲間</p>
                </div>

                <div className="text-center p-6 bg-purple-50 rounded-xl">
                  <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-handshake-line text-white text-2xl"></i>
                    </div>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">パートナー</h4>
                  <p className="text-sm text-gray-600">信頼関係を構築</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://public.readdy.ai/ai/img_res/3db93912c298949f59516291f9f2afd7.jpg"
                alt="チームワーク"
                className="w-full rounded-2xl shadow-2xl object-cover object-top"
              />
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-blue-100 rounded-full opacity-70 z-0"></div>
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-green-100 rounded-full opacity-70 z-0"></div>
            <div className="absolute top-1/2 -right-4 w-16 h-16 bg-purple-100 rounded-full opacity-50 z-0"></div>
          </div>
        </div>
      </div>
    </section>
  );
}